/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {TombOfAkhenatenServerDataParser} from "../TombOfAkhenatenServerDataParser";
import {ITombOfAkhenatenGameData} from "./ITombOfAkhenatenServerData";

export class TombOfAkhenatenParsedGameData extends SpinParsedGameData {
    public get accumulatedRoundWin(): string {
        return this._accumulatedRoundWin;
    }
    get showPyramidsReel(): boolean[] {
        return this._showPyramidsReel;
    }
    // get betWins(): boolean[] {
    //     return this._showPyramidsReel;
    // }
    //
    //
    private _showPyramidsReel: boolean[];

    get finalSpinWildPositions(): number[][] {
        return this._finalSpinWildPositions;
    }

    get pyramidReelLand(): boolean[] {
        return this._pyramidReelLand;
    }

    get evaluatedArea(): string[][] {
        return this._evaluatedArea;
    }

    get extraWildPosition(): number[] {
        return this._extraWildPosition;
    }

    private _extraWildPosition: number[];
    private _evaluatedArea: string[][];
    private _pyramidReelLand: boolean[];
    private _accumulatedRoundWin: string;
    private _finalSpinWildPositions: number[][];

    constructor(rawData: ITombOfAkhenatenGameData, dataParser: TombOfAkhenatenServerDataParser) {
        super(rawData, dataParser);

        this._stickySymbols = dataParser.parseStickySymbols(rawData);
        this._activeRows = dataParser.parseActiveRows(rawData);
        this._activeRowsNextSpin = dataParser.parseActiveRowsNextSpin(rawData);
        this._payoutMultiplier = dataParser.parsePayoutMultiplier(rawData);
        this._payoutMultiplierBefore = dataParser.parsePayoutMultiplierBefore(rawData);
        this._payoutMultiplierNextSpin = dataParser.parsePayoutMultiplierNextSpin(rawData);

        this._nearWinPositions = dataParser.parseNearWinPositions(rawData);
        this._extraWildPosition = dataParser.getExtraWildPosition(rawData);
        this._evaluatedArea = dataParser.getEvaluatedArea(rawData);
        this._pyramidReelLand = dataParser.getPyramidReelLand(rawData);
        this._finalSpinWildPositions = dataParser.getFinalSpinWildPositions(rawData);
        this._showPyramidsReel = dataParser.getShowPyramidsReel(rawData);
        this._accumulatedRoundWin = rawData.accumulatedRoundWin;
    }

    private _stickySymbols: string[][] = [];

    get stickySymbols(): string[][] {
        return this._stickySymbols;
    }

    private _activeRows: number;

    get activeRows(): number {
        return this._activeRows;
    }

    private _activeRowsNextSpin: number;

    get activeRowsNextSpin(): number {
        return this._activeRowsNextSpin;
    }

    private _payoutMultiplier: number;

    get payoutMultiplier(): number {
        return this._payoutMultiplier;
    }

    private _payoutMultiplierBefore: number;

    get payoutMultiplierBefore(): number {
        return this._payoutMultiplierBefore;
    }

    private _payoutMultiplierNextSpin: number;

    get payoutMultiplierNextSpin(): number {
        return this._payoutMultiplierNextSpin;
    }

    private _nearWinPositions: boolean[][];

    get nearWinPositions(): boolean[][] {
        return this._nearWinPositions;
    }
}